import gsap from "gsap/all";



export default function ComponentEngagement() {

    const components = document.querySelectorAll('.c-engagement')
    if (components.length > 0) {
        components.forEach(comp => new Engagement(comp))
    } 
}

class Engagement {
    constructor(DOM) {
        this.DOM = DOM;
        this.animationOnEnter()
    }

    animationOnEnter() {
        gsap.from(this.DOM.querySelectorAll('.c-engagement__title, .c-engagement__intro, .c-engagement__item'), {
            scrollTrigger: this.DOM,
            autoAlpha: 0,
            y: 50,
            duration: .5,
            stagger: 0.2,
        })

    }
}